<script lang="ts">
  export let color: string;
  export let marginRight: string;
</script>

<svg style="margin-right: {marginRight}" width="15" height="14" viewBox="0 0 15 14" fill="none">
  <path d="M1 7L14 7" stroke={color} stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8 1L14 7L8 13" stroke={color} stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
</svg>
